/**
 * Autopilot: what Ask Addy does while the loan officer is away, shown as the assistant's profile
 * (after the lendy-ui design): Identity (instructions and memory) and Scheduled tasks. See ./profile.
 */
import { useMemo } from "react";
import LendyProfile from "./profile/LendyProfile";

export default function AutopilotPanel({ agentId, organizationId, userId, loanId, assistantName, assistantImageUrl, isPanel, side, isCloseInRail, initialTab, onTabChange, onOpenThread, onClose, onUnreadChange }) {
  const identity = useMemo(() => ({ organizationId, userId, loanId }), [organizationId, userId, loanId]);
  return (
    <LendyProfile
      agentId={agentId}
      assistantName={assistantName}
      assistantImageUrl={assistantImageUrl}
      identity={identity}
      isPanel={isPanel}
      side={side}
      isCloseInRail={isCloseInRail}
      initialTab={initialTab}
      onTabChange={onTabChange}
      onClose={onClose}
      onOpenThread={onOpenThread}
      onUnreadChange={onUnreadChange}
    />
  );
}
